export class RegiaoIntegracaoImportFilter {
    idIntegracao: number;
    codigoIntegracao: string;
    nome: string;
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;
}
